import { render, staticRenderFns } from "./quota.vue?vue&type=template&id=696150ee&"
import script from "./quota.vue?vue&type=script&lang=js&"
export * from "./quota.vue?vue&type=script&lang=js&"
import style0 from "./quota.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports